/**
 * MQTT PTT 设备音频会话状态机（V2）
 * @see docs/MQTT_PTT_AUDIO_FIX_V1.md
 */

export type AudioSessionState =
  | 'INIT'
  | 'MQTT_CONNECTED'
  | 'PIPELINE_WARMING'
  | 'AUDIO_READY'
  | 'IDLE'
  | 'PTT_ACTIVE'
  | 'STREAMING';

/** Opus 编码器预热帧数（20ms/帧）；.env: REACT_APP_OPUS_WARMUP_FRAMES，默认 50 */
export function getOpusWarmupFrameCount(): number {
  const raw = (process.env.REACT_APP_OPUS_WARMUP_FRAMES || '').trim();
  const n = parseInt(raw, 10);
  if (Number.isFinite(n) && n >= 1 && n <= 500) {
    return Math.floor(n);
  }
  return 50;
}

/** Worklet 首帧/steady 等待超时（ms） */
export function getPipelineFirstCaptureTimeoutMs(): number {
  const raw = (process.env.REACT_APP_PIPELINE_FIRST_CAPTURE_TIMEOUT_MS || '').trim();
  const n = parseInt(raw, 10);
  if (Number.isFinite(n) && n >= 1000 && n <= 30000) {
    return n;
  }
  return 8000;
}

/**
 * FORCE_AUDIO_GRAPH_ACTIVATION：静音预激活时长（ms）
 * .env: REACT_APP_FORCE_AUDIO_ACTIVATION_MS，默认 800
 */
export function getForceAudioActivationMs(): number {
  const raw = (process.env.REACT_APP_FORCE_AUDIO_ACTIVATION_MS || '').trim();
  const n = parseInt(raw, 10);
  if (Number.isFinite(n) && n >= 500 && n <= 5000) {
    return Math.floor(n);
  }
  return 800;
}

/** 20ms/包 @ 48kHz Worklet 上行 */
export const UPLINK_CAPTURE_FRAME_MS = 20;

/** FORCE 阶段最少采集 Worklet 包数（由时长推导，至少 25 包≈0.5s） */
export function getForceCaptureMinFrameCount(): number {
  const ms = getForceAudioActivationMs();
  return Math.max(25, Math.ceil(ms / UPLINK_CAPTURE_FRAME_MS));
}
